import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BuildEnvironment } from "src/environments/environment";
import { AgencyContactInformation } from "../models/agency-contact-info.model";

@Injectable({
  providedIn: "root",
})
export class AgencyContactInfoService {
  private baseurl = BuildEnvironment.GetEnvironmentUrl() + "/myprofile/companyinformation";

  constructor(private http: HttpClient) {}

  getAgencyContactInfo(id: string): Observable<AgencyContactInformation> {
    return this.http.get<AgencyContactInformation>(this.baseurl + `/agencycontactinfo/${id}`);
  }

  updateAgentProfile(
    contactInfo: any,
    agencyId: string
  ): Observable<AgencyContactInformation> {
    return this.http.post<AgencyContactInformation>(
      this.baseurl + `/update/${agencyId}`,
      contactInfo
    );
  }
}
